import React, { memo } from 'react';

import { Checkbox as MuiCheckbox } from '@mui/material';
import PropTypes from 'prop-types';

import { checkboxStyles } from './Checkbox.styles';

const CheckboxIcon = ({ size, borderColorHex }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 22 22"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect height="20" rx="3.5" stroke={borderColorHex} width="20" x="1.25" y="1" />
  </svg>
);

const CheckboxCheckedIcon = ({ size, fillColorHex }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 22 22"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#a)">
      <path d="M.25.5h21v21h-21z" fill={fillColorHex} />
      <path d="m6.25 10 4 4 6.5-6.5" stroke="#fff" strokeWidth="2" />
    </g>
    <defs>
      <clipPath id="a">
        <rect fill="#fff" height="21" rx="4" width="21" x=".25" y=".5" />
      </clipPath>
    </defs>
  </svg>
);

const Checkbox = ({
  size = '22',
  checked,
  disabled = false,
  borderColorHex = '#999',
  fillColorHex = '#3E83DC',
  onChange,
  ...props
}) => (
  <MuiCheckbox
    disableTouchRipple
    checked={checked}
    checkedIcon={<CheckboxCheckedIcon fillColorHex={fillColorHex} size={size} />}
    disabled={disabled}
    icon={<CheckboxIcon borderColorHex={borderColorHex} size={size} />}
    sx={checkboxStyles}
    onChange={onChange}
    {...props}
  />
);

Checkbox.propTypes = {
  checked: PropTypes.bool.isRequired,
  borderColorHex: PropTypes.string,
  disabled: PropTypes.bool,
  fillColorHex: PropTypes.string,
  size: PropTypes.string,
  onChange: PropTypes.func,
};

CheckboxIcon.propTypes = {
  size: PropTypes.string.isRequired,
  borderColorHex: PropTypes.string.isRequired,
};

CheckboxCheckedIcon.propTypes = {
  size: PropTypes.string.isRequired,
  fillColorHex: PropTypes.string.isRequired,
};

export default memo(Checkbox);
